module.exports = __webpack_public_path__ + "img/Facebook_footer.d7d1ccb4.svg";